import axios from 'axios';

const API_URL = 'https://admin.defconinnovations.com/api/login/';

export const login = async credentials => {
  const response = await axios.post(`${API_URL}`, credentials);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
};
